<template>
  <div class="learner-home">
    <div class="coach-assignments" v-if="!!+assignment_settings">
      <div class="block-header">
        <div class="md-title">{{ coachAssignmentsLabel }}</div>
        <div
          class="pager"
          v-if="
            ($mq == 'large' || $mq == 'xlarge') && assignments.length > size
          "
        >
          <button
            class="pager-nav button-previous"
            @click="prevPage"
            :disabled="pageNumber === 0"
          >
            Previous
          </button>
          <button
            class="pager-nav button-next"
            @click="nextPage"
            :disabled="pageNumber >= pageCount - 1"
          >
            Next
          </button>
        </div>
      </div>
      <div v-if="assignments.length" class="assignments-cards">
        <md-card
          v-if="$mq == 'large' || $mq == 'xlarge'"
          class="assignments-item md-layout-item overflow-hidden"
          tabindex="0"
          :key="index"
          v-for="(item, index) in paginatedData"
          md-with-hover
          @click.native="openAssignment(item)"
          @keypress.native.enter="openAssignment(item)"
        >
          <md-card-content>
            <div class="assignment-due-date">
              <span v-if="item.status_code == $assignment_status.ASSIGNMENT_REVIEW_NEEDED">
                {{ $assignment_status_text[$assignment_status.ASSIGNMENT_REVIEW_NEEDED] }}
              </span>
              <span v-else-if="item.due_date">
                Due {{ item.due_date }}
              </span>
            </div>
            <div class="assignment-title">{{ item.title }}</div>
            <div class="assignment-coach" v-if="item.coach">
              {{ item.coach }}
            </div>
          </md-card-content>
        </md-card>

        <carousel
          :perPage="1"
          :navigationEnabled="true"
          :paginationEnabled="false"
          v-else
        >
          <slide
            :key="index"
            v-for="(item, index) in assignments"
            md-with-hover
            @click.native="openAssignment(item)"
            @keypress.native.enter="openAssignment(item)"
            tabindex="0"
          >
            <md-card class="assignments-item md-layout-item overflow-hidden">
              <md-card-content>
                <span v-if="item.status_code == $assignment_status.ASSIGNMENT_REVIEW_NEEDED">
                  {{ $assignment_status_text[$assignment_status.ASSIGNMENT_REVIEW_NEEDED] }}
                </span>
                <span v-else-if="item.due_date">
                  Due {{ item.due_date }}
                </span>
                <div class="assignment-title">{{ item.title }}</div>
                <div class="assignment-coach" v-if="item.coach">
                  Assigned by {{ item.coach }}
                </div>
              </md-card-content>
            </md-card>
          </slide>
        </carousel>
      </div>
      <div v-else class="assignments-cards">
        <div class="empty-text">Nothing new at this time.</div>
      </div>
    </div>

    <div v-show="showSuccessMessage" class="no-line text-left success-message-wrapper">
      <div class="success-message" v-html="successMessage"></div>
    </div>

    <div class="learning-paths" v-if="learningPaths.length">
      <div class="block-header">
        <div class="md-title">{{ recommendedForYouLabel }}</div>
      </div>
      <div class="learning-content">
        <div class="list" :key="pId" v-for="(path, pId) in shownPaths">
          <md-list @keypress.native.enter="togglePath(path)" tabindex="0">
            <md-list-item
              :md-expanded.sync="expandedPath[path.id]"
              md-expand
              :md-ripple="false"
              @click="expandedPath[path.id] = !expandedPath[path.id]"
            >
              <div class="learning-path-header">
                <div class="row">
                  <div class="learning-title">{{ path.title }}</div>
                  <div v-if="path.progress_type == 'number'" class="path-progress-number"><span>{{ path.completed_count }} out of {{ path.activities.length }} completed</span></div>
                  <div v-else class="path-progress">
                    <div
                      class="completed"
                      :class="{ light: parseInt(path.completed) < 15 }"
                      :style="'width:' + path.completed + '%'"
                    >
                      <span>{{ path.completed }}%</span>
                    </div>
                  </div>
                  <!--<div class="lp-menu">
                    <md-menu md-size="small" :md-offset-x="-140" :md-offset-y="-32">
                      <md-button md-menu-trigger class="lp-menu-trigger md-icon-button" @click.stop>
                        <md-icon>more_horiz</md-icon>
                      </md-button>
                      <md-menu-content class="lp-menu">
                        <md-menu-item @click="toggleDialog(path)" class="md-button" :disabled="path.completed == 100">Unenroll</md-menu-item>
                      </md-menu-content>
                    </md-menu>
                    <md-dialog :md-active.sync="showUnenrollDialog[path.id]" class="unenroll-dialog">
                      <md-dialog-title>Are you sure you want to unenroll?</md-dialog-title>
                      <md-dialog-actions>
                        <md-button class="md-secondary" @click="toggleDialog(path)">No</md-button>
                        <md-button class="md-primary" @click="unenroll(path)">Yes</md-button>
                      </md-dialog-actions>
                    </md-dialog>
                  </div>-->
                </div>
                <div class="icon-more-less">
                  <md-icon class="expand">expand_more</md-icon>
                </div>
              </div>
              <div class="result" slot="md-expand">
                <div class="result-wrapper">
                  <div v-if="path.additional_info" class="lp-additional-info">{{ path.additional_info }}</div>
                  <md-card
                    class="activity-data row md-layout-item overflow-hidden"
                    :class="'activity-status-' + activity.statusCode + (activity.before_open ? ' activity-not-open' : '')"
                    md-with-hover
                    :key="key"
                    v-for="(activity, key) in path.activities"
                    @click.native="goTo(activity)"
                    @keypress.native.enter="goTo(activity)"
                    :tabindex="expandedPath[path.id] ? 0 : -1"
                  >
                    <md-card-content class="row">
                      <div class="title-wrapper">
                        <img
                          class="icon"
                          v-if="activity.icon"
                          :alt="activity.title + ' icon'"
                          :src="activity.icon"
                        />
                        <div class="learning-title">{{ activity.title }}</div>
                      </div>
                      <div class="activity-status">
                        <div v-if="activity.before_open" class="activity-locked">
                          <md-tooltip md-direction="left">Available {{ activity.open_at }}</md-tooltip>
                        </div>
                        {{ activity.status }}
                        <i
                          class="md-icon md-icon-font md-theme-default"
                          v-if="activity.statusCode != 4"
                          >arrow_right_alt</i
                        >
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
                <div class="icon-more-less" @click="togglePath(path)">
                  <md-icon class="expand">expand_less</md-icon>
                </div>
              </div>
            </md-list-item>
          </md-list>
        </div>
        <div class="icon-more-less">
          <md-button
            v-if="!learningShowAll && learningPaths.length > pathSize"
            @click="learningShowAll = !learningShowAll"
            class="show-all md-button"
            >Show all</md-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "LearnerHome",
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      pageNumber: 0,
      size: this.$mq == "large" || this.$mq == "xlarge" ? 3 : 1,

      assignments: window.drupalSettings.controller.assignments || [],
      coachAssignmentsLabel:
        window.drupalSettings.group_catch_config.labels.coach_assignments || "",
      learningShowAll: 0,
      learningPaths: window.drupalSettings.controller.learning_paths || [],
      recommendedForYouLabel:
        window.drupalSettings.group_catch_config.labels.learning_paths,
      expandedPath: [],
      pathSize: 3,
      assignment_settings: window.drupalSettings.controller.assignment_settings,
      showUnenrollDialog: {},
      showSuccessMessage: null,
      successMessage: 'You have been successfully unenrolled.',
    };
  },
  mounted() {
    if (this.assignments.length > 0) {
      this.assignments.sort((a, b) => {
        if (b.status_code > a.status_code) {
          return -1;
        } else if (b.status_code < a.status_code) {
          return 1;
        };
        return 0;
      });
    }
    this.size = this.$mq == "large" || this.$mq == "xlarge" ? 3 : 1;
    this.learningPaths.forEach((v) => {
      this.expandedPath[v.id] = false;
      Vue.set(this.showUnenrollDialog, v.id, false);
    });
  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    togglePath(path) {
      Vue.set(this.expandedPath, path.id, !this.expandedPath[path.id]);
    },
    goTo(node) {
      if (node.before_open) {
        return;
      }
      window.location.href = "/node/" + node.id;
    },
    openAssignment(item) {
      window.location.href = "/" + item.route + "/" + item.id;
    },
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
    toggleDialog(path) {
      Vue.set(this.showUnenrollDialog, path.id, !this.showUnenrollDialog[path.id]);
    },
    unenroll(path) {
      Vue.set(this.showUnenrollDialog, path.id, false);
      this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/json");
        fetch_headers.append("X-CSRF-Token", token);
        fetch("/rlxp/unenroll/" + path.id + "/" + window.drupalSettings.user.uid, {
          credentials: "include",
          method: "GET",
          headers: fetch_headers,
        })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.status) {
            Vue.set(this.showUnenrollDialog, path.id, false);
            this.showSuccessMessage = true;
            this.successMessage = 'You have been successfully unenrolled from ' + path.title + '.';
            this.learningPaths = this.learningPaths.filter(function( obj ) {
              return obj.id !== path.id;
            });
          }
          else if (!data.status && data.message) {
            console.log(data.message);
          }
        });
      });
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          return text;
        });
    },
  },
  computed: {
    pageCount() {
      let l = this.assignments.length,
        s = this.size;
      return Math.ceil(l / s);
    },
    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      return this.assignments.slice(start, end);
    },
    shownPaths() {
      if (!this.learningShowAll) {
        return this.learningPaths.slice(0, this.pathSize);
      }
      return window.drupalSettings.controller.learning_paths;
    },
  },
};
</script>

<style lang="scss">
.overflow-hidden {
  overflow: hidden !important;
}

.block-header {
  display: flex;
  justify-content: space-between;
  color: $title-blue;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  margin: 16px 16px 16px;
  @media all and (max-width: $breakpoint-medium) {
    margin: 16px 0px;
  }
  .md-title {
    font-weight: bold;
    @media all and (max-width: $breakpoint-medium) {
      font-size: 16px;
    }
  }
}

.md-icon-font.expand {
  color: $blue-dark;
  font-size: 35px !important;
}

.coach-assignments {
  margin-bottom: 30px;

  .md-card-content {
    padding: 22px 30px;
  }
  .pager {
    display: inline-flex;
  }

  .VueCarousel-navigation {
    position: absolute;
    right: 25px;
    top: -20px;
  }
  .VueCarousel-navigation-next {
    color: transparent !important;
    &:before {
      content: "";
      display: block;
      width: 20px;
      height: 16px;
      background: url("./assets/double-arrow-right.svg") center no-repeat;
    }
  }
  .VueCarousel-navigation-prev {
    color: transparent !important;
    &:before {
      content: "";
      display: block;
      width: 20px;
      height: 16px;
      background: url("./assets/double-arrow-right.svg") center no-repeat;
      transform: rotate(180deg);
    }
  }
  button.pager-nav {
    border: none;
    font-size: 1px;
    color: transparent;
    line-height: initial;
    background: transparent;
    padding: 3px;
    cursor: pointer;

    &:before {
      content: "";
      display: block;
      width: 20px;
      height: 16px;
      background: url("./assets/double-arrow-right.svg") center no-repeat;
    }
    &[disabled="disabled"]:before {
      opacity: 0.5;
    }
    &.button-previous:before {
      transform: rotate(180deg);
    }
  }

  .assignments-cards {
    .empty-text {
      margin: 0 17px;
      color: $blue-dark;
    }
  }
  .assignments-item {
    position: relative;
    transition: var(--transition);
    background-color: $white;
    margin: 0 0 15px;
    color: #3c3c3c;
    .assignment-due-date {
      font-size: 14px;
      text-transform: uppercase;
      margin-bottom: 7px;
      @media all and (max-width: $breakpoint-medium) {
        font-size: 12px;
      }
    }
    .assignment-title {
      color: $title-blue;
      max-height: 60px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-bottom: 7px;
      font-size: 20px;
      font-weight: bold;
      @media all and (max-width: $breakpoint-medium) {
        font-size: 16px;
      }
    }
    .assignment-coach {
      font-family: $font-source-sans-pro;
      font-size: 16px;
      @media all and (max-width: $breakpoint-medium) {
        font-size: 12px;
      }
    }
    &:after {
      content: "";
      position: absolute;
      display: block;
      right: 0;
      bottom: 0;
      transition: var(--transition);
      width: 75px;
      height: 84px;
      background: url("./assets/coach-assignment-icon.svg") center no-repeat;
    }
    &:hover {
      background-color: $white;
      transform: scale(1.01, 1.01);
      transition: var(--transition);
      &:after {
        width: 79px;
        height: 91px;
      }
    }
  }

  .assignments-cards {
    @media all and (min-width: $breakpoint-medium) {
      display: flex;
      flex-wrap: wrap;
      margin-left: -8px;
      margin-right: -8px;
      .assignments-item {
        flex-basis: calc(33.3% - 20px);
        margin: 10px 10px;
        max-width: calc(33.3% - 20px);
        height: 145px;
      }
      .empty-text {
        margin: 0 23px;
      }
    }
    .assignments-item {
      height: 145px;
    }
  }
}

.learning-paths {
  .md-list.md-theme-default
    .md-list-item-expand:not(.md-list-item-default):not([disabled])
    > .md-list-item-content:hover {
    background: transparent;
  }
  .icon-more-less {
    text-align: center;
    .md-icon {
      color: $blue-dark !important;
    }
  }
  button.show-all {
    background: $blue-dark;
    color: $white;
    border-radius: 20px;
    width: 70%;
    max-width: 357px;
    height: 40px;
    font-size: 20px;
    font-weight: bold;
  }
  .list {
    margin-bottom: 24px;
    ul {
      padding: 0;
      background: transparent;
    }
    li {
      position: relative;
      background: $white;
      transition: var(--transition);
      border-radius: 20px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
      &:hover {
        transition: var(--transition);
        border-radius: 20px;
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
          0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
      }
    }
  }
  .md-list-item-container {
    border: none;
    &.md-active .learning-path-header .icon-more-less {
      display: none;
    }
  }
  .md-list-item-content {
    padding: 0 20px;
  }
  .md-icon.md-list-expand-icon {
    display: none;
  }
  .learning-title {
    max-height: 60px;
    overflow: hidden;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
    color: $blue-dark;
    margin: 15px 0;
    padding-right: 16px;
    @media all and (max-width: $breakpoint-medium) {
      font-size: 16px;
    }
  }
  .learning-path-header {
    width: 100%;
    .path-progress {
      height: 18px;
      width: 100%;
      font-size: 14px;
      font-weight: bold;
      color: $white;
      border-radius: 5px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
      margin: 15px 0;
      .completed {
        border-radius: 5px;
        background: $blue-active;
        text-align: right;
        span {
          margin-right: 7px;
        }
        &.light {
          span {
            margin-right: -29px;
            color: $blue-active;
          }
        }
      }
    }
  }
  .lp-menu {
    position: absolute;
    right: 8px;
    top: 20px;
    .lp-menu-trigger {
      height: 20px;
      .md-icon {
        color: $blue-dark;
      }
    }
  }
  .result {
    padding: 0 20px;
    .icon-more-less {
      margin-top: 12px;
      cursor: pointer;
    }
    .activity-data {
      margin-top: 12px;
      &.activity-not-open {
        cursor: default;
      }
      .md-card-content {
        padding: 0 15px;
        width: 100%;
      }
      .title-wrapper {
        display: flex;
        align-items: center;
        width: 100%;
      }
      img.icon {
        max-height: 60px;
        margin-right: 10px;
      }
      .activity-locked {
        background-image: url("./assets/locked-padlock-icon.svg");
        background-repeat: no-repeat;
        background-size: 20px;
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: top;
        margin-right: 10px;
        cursor: pointer;
      }
      .activity-status {
        text-transform: uppercase;
        margin: 15px 0;
        color: #3c3c3c;
        min-width: 145px;
        transition: var(--transition);
        @media all and (max-width: $breakpoint-medium) {
          font-size: 12px;
        }
        .md-icon-font {
          color: $blue-active;
          font-size: 35px !important;
          margin-top: -5px;
          margin-left: 10px;
          opacity: 0;
          transition: var(--transition);
        }
      }
      &:hover {
        .activity-status {
          min-width: 140px;
          transition: var(--transition);
          .md-icon-font {
            opacity: 1;
            transition: var(--transition);
          }
        }
        &:not(.activity-not-open):hover {
          .activity-status md-icon-font {
            opacity: 1;
            transition: var(--transition);
          }
        }
      }
      &.activity-status-4 {
        background: #e2f3e4;
        .activity-status {
          position: relative;
          &::after {
            content: "";
            position: absolute;
            top: -9px;
            margin-left: 16px;
            width: 35px;
            height: 41px;
            background: url(./assets/badge.svg) center no-repeat;
            background-size: contain;
          }
        }
      }
      &.activity-not-open .activity-status {
        min-width: 180px;
      }
      &.activity-not-open:hover .activity-status {
        min-width: 175px;
      }
    }
  }
  .lp-additional-info {
    font-family: $font-source-sans-pro;
    font-style: italic;
    padding: 8px 0;
    white-space: normal;
  }

  @media all and (min-width: $breakpoint-small) {
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 60px;
    }
    .result,
    .md-list-item-content {
      padding: 0 30px;
    }
    .learning-title {
      overflow: hidden;
      width: calc(100% - 70px);
      margin: 0 10px 0 0;
    }
    .learning-path-header {
      padding: 4px 0;
      .row {
        align-items: flex-end;
      }
      .path-progress {
        margin: 0;
        width: 350px;
      }
    }
    .result .activity-data {
      .md-card-content {
        padding: 15px;
      }
      .title-wrapper {
        width: calc(100% - 250px);
      }
    }
  }
}

.page-learner .md-tooltip.md-theme-default {
  margin-top: -20px;
}

.lp-menu.md-menu-content {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 20px;
  .md-list {
    padding: 0;
    border-radius: 20px;
    .md-list-item {
      margin: 0;
      border-radius: 0;
      &:first-child {
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
      }
      &:last-child {
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
      }
      button {
        background-color: $white;
        color: $blue-dark;
        font-weight: 600;
      }
      &[disabled] button {
        color: $grey-dark;
        background: $grey-light;
        opacity: 0.6;
      }
    }
    .md-list-item-content {
      min-height: 46px;
    }
  }
}

.unenroll-dialog {
  padding: 0.5rem;
  .md-dialog-title {
    color: $title-blue;
  }
  .md-dialog-actions {
    .md-button.md-primary.md-primary {
      background: $blue-dark;
    }
    .md-secondary {
      color: $blue-dark;
    }
  }
}
</style>
